import { Controller } from "@hotwired/stimulus";

// Progressive disclosure for onboarding CSV upload:
// - Shows Member Upload Category only when Import Type = Members
// - Shows file upload only after type (and category, if members) is selected
// - Shows confirmation summary when file is selected
export default class extends Controller {
  static targets = ["memberOptions", "memberCategory", "fileUpload", "confirmation", "submitBtn"];

  connect() {
    this.importTypeLabels = {
      members: "Members",
      activity: "Attendance",
      payments: "Payments",
    };
    this.modeLabels = {
      categorized: "Categorized",
      full_import: "Full Historical",
    };
    this.categoryLabels = {
      active: "Active Members",
      churned: "Churned Members",
      paused: "Paused Members",
    };
    this.update();
  }

  toggleCategory() {
    this.update();
  }

  updateFileAndConfirmation() {
    this.update();
  }

  update() {
    const typeSelect = this.element.querySelector('select[name="import_type"]');
    const modeRadio = this.element.querySelector('input[name="member_import_mode"]:checked');
    const categorySelect = this.element.querySelector('select[name="member_upload_category"]');
    const fileInput = this.element.querySelector('input[type="file"][name="file"]');

    const importType = typeSelect?.value?.trim() || "";
    const mode = modeRadio?.value?.trim() || "";
    const category = categorySelect?.value?.trim() || "";
    const hasFile = fileInput?.files?.length > 0;
    const fileName = hasFile ? fileInput.files[0].name : "";

    const isMembers = importType === "members";
    const isCategorized = mode === "categorized";

    // Show/hide member options (import mode + category)
    if (this.hasMemberOptionsTarget) {
      this.memberOptionsTarget.classList.toggle("hidden", !isMembers);
      if (!isMembers) {
        if (categorySelect) categorySelect.value = "";
      }
    }

    // Show category only when members + categorized
    if (this.hasMemberCategoryTarget) {
      this.memberCategoryTarget.classList.toggle("hidden", !(isMembers && isCategorized));
      if (!isCategorized && categorySelect) categorySelect.value = "";
    }

    // Can upload: type selected, and for members: mode selected and (full_import or category selected)
    const canUpload =
      importType !== "" &&
      (importType !== "members" || (mode !== "" && (mode === "full_import" || category !== "")));
    if (this.hasFileUploadTarget) {
      this.fileUploadTarget.classList.toggle("hidden", !canUpload);
    }

    // Show confirmation summary when file is selected
    if (this.hasConfirmationTarget) {
      const showConfirmation = canUpload && hasFile;
      this.confirmationTarget.classList.toggle("hidden", !showConfirmation);
      const modeRow = this.confirmationTarget.querySelector("[data-role='mode-row']");
      const categoryRow = this.confirmationTarget.querySelector("[data-role='category-row']");
      if (modeRow) modeRow.classList.toggle("hidden", !isMembers);
      if (categoryRow) categoryRow.classList.toggle("hidden", !(isMembers && isCategorized));
      if (showConfirmation) {
        this.confirmationTarget.querySelector("[data-role='import-type']").textContent =
          this.importTypeLabels[importType] || importType || "—";
        this.confirmationTarget.querySelector("[data-role='mode']").textContent =
          isMembers ? (this.modeLabels[mode] || mode || "—") : "—";
        this.confirmationTarget.querySelector("[data-role='category']").textContent =
          isMembers && isCategorized ? (this.categoryLabels[category] || category || "—") : "—";
        this.confirmationTarget.querySelector("[data-role='file-name']").textContent = fileName;
      }
    }

    // Enable/disable submit
    const canSubmit = canUpload && hasFile;
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = !canSubmit;
    }
  }
}
